import { render, staticRenderFns } from "./AreaDetailsPm.vue?vue&type=template&id=1a3e92d6&scoped=true&"
import script from "./AreaDetailsPm.vue?vue&type=script&lang=js&"
export * from "./AreaDetailsPm.vue?vue&type=script&lang=js&"
import style0 from "./AreaDetailsPm.vue?vue&type=style&index=0&id=1a3e92d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e92d6",
  null
  
)

export default component.exports